
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5CdDA", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $cJRFO = parcelRequire("cJRFO");


var $71WeF = parcelRequire("71WeF");


var $kQuIn = parcelRequire("kQuIn");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $ce4Ui = parcelRequire("ce4Ui");

const $022942c74238e47f$var$getGoogleDriveTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $dz5JF.TypeFilterValueKey).Document, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Document,
            (0, $dz5JF.NounSubtypeKey).Pdf,
            (0, $dz5JF.NounSubtypeKey).Page,
            (0, $dz5JF.NounSubtypeKey).Blogpost
        ]
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Spreadsheet, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Spreadsheet
        ]
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Presentation, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Presentation
        ]
    });
    if ((0, $dh538.fg)('rovo_fps_enable_video_noun_filter')) config.set((0, $dz5JF.TypeFilterValueKey).Video, {
        entities3P: [
            ...(0, $kQuIn.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Video
        ]
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Image, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Image
        ]
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Folder, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Folder
        ]
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Audio, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Audio
        ]
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Pdf, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Pdf
        ]
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Code, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Code
        ]
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Form, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Form
        ]
    });
    // Back-ported (consolidated) shape — replaces individual Page/Blogpost entries
    // with a richer WebPage entry and folds Archive into Other.
    config.set((0, $dz5JF.TypeFilterValueKey).Notebook, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Notebook
        ]
    });
    config.set((0, $dz5JF.TypeFilterValueKey).WebPage, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).WebPage,
            (0, $dz5JF.NounSubtypeKey).Shortcut
        ]
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Other, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $dz5JF.NounSubtypeKey).Other,
            (0, $dz5JF.NounSubtypeKey).Archive
        ]
    });
    // Comments are embedded within documents as linkedEntities, not standalone entities.
    // Keep the entity type aligned to document results so any consumer of typeFilterConfig still
    // treats Google Drive comment matches as documents rather than standalone comments.
    if ((0, $dh538.fg)('enable_3p_embedded_comments_search')) config.set((0, $dz5JF.TypeFilterValueKey).Comment, {
        entities3P: [
            ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    return config;
};
const $022942c74238e47f$export$6634ddcb22ed69a = {
    displayName: 'Google Drive',
    id: 'drive',
    resourceType: (0, $78z3f.ProductResourceTypes3P).GoogleDrive,
    icon: (0, $fj6km.get3PLogo)((0, $ce4Ui.GoogleDriveIcon), 'Google Drive', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $ce4Ui.GoogleDriveIconBorderless), 'Google Drive', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $ce4Ui.GoogleDriveSearchResultIcon), 'Google Drive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    // Use a getter to evaluate lazily so that it's evaluated when accessed, not at module load.
    // This allows for feature gate mocks in tests to work correctly
    get typeFilterConfig () {
        return $022942c74238e47f$var$getGoogleDriveTypeFilterConfig();
    },
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'onlyTitleMatch'
        ];
        if ((0, $dh538.fg)('rovo_fps_enable_gdrive_space_filter')) baseFilters.push('space');
        if ((0, $dh538.fg)('rovo_fps_enable_gdrive_content_filter')) baseFilters.push('content');
        return baseFilters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["googleDriveConfig"] = $022942c74238e47f$export$6634ddcb22ed69a;

});

parcelRegister("cJRFO", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $dd0d86a6eef7eeb2$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $dd0d86a6eef7eeb2$export$d520529b4595d46c;

});

parcelRegister("71WeF", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $8b8c4a19dc45a1eb$export$1dc2d469fb044d48 = [
    'ati:cloud:graph:remote-link'
];
module.exports["DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI"] = $8b8c4a19dc45a1eb$export$1dc2d469fb044d48;

});

parcelRegister("kQuIn", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $f2d4a2cb14cdae7d$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $f2d4a2cb14cdae7d$export$a3d7cddace4fe237;

});

parcelRegister("dz5JF", function(module, exports) {
const $6067fc387d431c0b$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Ask: 'ask',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article'
};
const $6067fc387d431c0b$export$e01073b80ff953d5 = Object.values($6067fc387d431c0b$export$49f6cbb853d30562);
const $6067fc387d431c0b$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $6067fc387d431c0b$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': $6067fc387d431c0b$export$49f6cbb853d30562.Document,
    'ati:cloud:graph:message': $6067fc387d431c0b$export$49f6cbb853d30562.Message,
    'ati:cloud:graph:conversation': $6067fc387d431c0b$export$49f6cbb853d30562.Conversation,
    'ati:cloud:graph:design': $6067fc387d431c0b$export$49f6cbb853d30562.Design,
    'ati:cloud:graph:video': $6067fc387d431c0b$export$49f6cbb853d30562.Video,
    'ati:cloud:graph:space': $6067fc387d431c0b$export$49f6cbb853d30562.Space,
    'ati:cloud:graph:comment': $6067fc387d431c0b$export$49f6cbb853d30562.Comment,
    'ati:cloud:graph:repository': $6067fc387d431c0b$export$49f6cbb853d30562.Repository,
    'ati:cloud:graph:pull-request': $6067fc387d431c0b$export$49f6cbb853d30562.PullRequest,
    'ati:cloud:graph:commit': $6067fc387d431c0b$export$49f6cbb853d30562.Commit,
    'ati:cloud:graph:branch': $6067fc387d431c0b$export$49f6cbb853d30562.Branch,
    'ati:cloud:graph:calendar-event': $6067fc387d431c0b$export$49f6cbb853d30562.Calendar,
    'ati:cloud:graph:work-item': $6067fc387d431c0b$export$49f6cbb853d30562.WorkItem,
    'ati:cloud:graph:project': $6067fc387d431c0b$export$49f6cbb853d30562.Project,
    'ati:cloud:graph:deal': $6067fc387d431c0b$export$49f6cbb853d30562.Deal,
    'ati:cloud:graph:customer-org': $6067fc387d431c0b$export$49f6cbb853d30562.CustomerOrg,
    'ati:cloud:graph:customer-contact': $6067fc387d431c0b$export$49f6cbb853d30562.CustomerContact,
    'ati:cloud:graph:dashboard': $6067fc387d431c0b$export$49f6cbb853d30562.Dashboard,
    'ati:cloud:graph:data-table': $6067fc387d431c0b$export$49f6cbb853d30562.DataTable,
    'ati:cloud:graph:campaign': $6067fc387d431c0b$export$49f6cbb853d30562.Campaign,
    'ati:cloud:graph:case': $6067fc387d431c0b$export$49f6cbb853d30562.Case
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $6067fc387d431c0b$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $6067fc387d431c0b$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($6067fc387d431c0b$var$isCloudGraphAti(ati)) {
        const typeKey = $6067fc387d431c0b$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: [] // Most configs use empty subTypes3P, can be extended if needed
    });
    return typeFilterConfig;
}
module.exports["TypeFilterValueKey"] = $6067fc387d431c0b$export$49f6cbb853d30562;
module.exports["NounSubtypeKey"] = $6067fc387d431c0b$export$1f2db89e0caa00c9;
module.exports["mapAtisToTypeFilterConfig"] = $6067fc387d431c0b$export$770175465f396551;

});

parcelRegister("fj6km", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");




var $1Teld = parcelRequire("1Teld");


var $9AqRO = parcelRequire("9AqRO");


var $6Fa33 = parcelRequire("6Fa33");


var $6RZzG = parcelRequire("6RZzG");




var $ce4Ui = parcelRequire("ce4Ui");

const $6784eda2893491f1$var$svgIconContainerStyles = {
    small: "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o",
    medium: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
    large: "_1bsbzwfg _4t3izwfg _1e0c1txw _4cvr1h6o _1bah1h6o",
    xlarge: "_1bsbzwfg _4t3izwfg _1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $6784eda2893491f1$var$SVGIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { glyph: SVG, label: label, size: size } = t0;
    const t1 = $6784eda2893491f1$var$svgIconContainerStyles[size];
    const t2 = label || undefined;
    const t3 = label ? "img" : "presentation";
    let t4;
    if ($[0] !== SVG) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SVG, null);
        $[0] = SVG;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t1,
            "aria-label": t2,
            role: t3
        }, t4);
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ glyph: SVG, label: label, size: size })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6784eda2893491f1$var$svgIconContainerStyles[size],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SVG, null));
};
const $6784eda2893491f1$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $6784eda2893491f1$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $6784eda2893491f1$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $6784eda2893491f1$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const mappedSize = size && $6784eda2893491f1$var$isCorrectableRovoSize(size) ? $6784eda2893491f1$var$correctedSize[size] : defaultSize;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $gMc0m.default)([
                $6784eda2893491f1$var$sizeStyles[mappedSize]
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $6784eda2893491f1$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6784eda2893491f1$var$SVGIcon, {
            label: label,
            glyph: glyph,
            size: size && $6784eda2893491f1$var$isCorrectableRovoSize(size) ? $6784eda2893491f1$var$correctedSize[size] : 'medium'
        });
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $6784eda2893491f1$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand",
            shouldUseNewLogoDesign: true
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $6784eda2893491f1$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            ...props,
            shouldUseNewLogoDesign: true
        });
}
function $6784eda2893491f1$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $6784eda2893491f1$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $6784eda2893491f1$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $6784eda2893491f1$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _5ral1f51"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $6784eda2893491f1$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $6784eda2893491f1$export$dae027fade2c6d1d($6784eda2893491f1$export$f9f7178f66750cba(iconUrl), iconLabel, size);
} // Jira-specific icons
module.exports["RovoLogoFromGlyph"] = $6784eda2893491f1$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $6784eda2893491f1$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $6784eda2893491f1$export$32db889b380fa03c;
module.exports["get3PLogo"] = $6784eda2893491f1$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $6784eda2893491f1$export$97ac28be52c9e29f;

});

parcelRegister("1Teld", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $6a4b6e784c7cb89d$var$LazyGithubIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("13zfh")).then((m)=>m.GithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/icon'
});

const $6a4b6e784c7cb89d$var$LazyGithubSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("13zfh")).then((m)=>m.GithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon'
});
const $6a4b6e784c7cb89d$export$e8e65f186ccd8749 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a4b6e784c7cb89d$var$LazyGithubIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a4b6e784c7cb89d$var$LazyGithubIconComponent, null));
const $6a4b6e784c7cb89d$export$fa0f141eb732d2d7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a4b6e784c7cb89d$var$LazyGithubSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a4b6e784c7cb89d$var$LazyGithubSearchResultIconComponent, null));
module.exports["GithubIcon"] = $6a4b6e784c7cb89d$export$e8e65f186ccd8749;
module.exports["GithubSearchResultIcon"] = $6a4b6e784c7cb89d$export$fa0f141eb732d2d7;

});

parcelRegister("dQYck", function(module, exports) {

var $apCPx = parcelRequire("apCPx");


var $56LFI = parcelRequire("56LFI");


var $kLgjN = parcelRequire("kLgjN");


var $9Fc44 = parcelRequire("9Fc44");


var $f8v34 = parcelRequire("f8v34");

var $ewDOk = parcelRequire("ewDOk");


var $4yMFN = parcelRequire("4yMFN");


var $dXi4e = parcelRequire("dXi4e");


var $1QGnA = parcelRequire("1QGnA");


var $1yW1K = parcelRequire("1yW1K");


var $lx2SU = parcelRequire("lx2SU");


var $j4Chq = parcelRequire("j4Chq");


function $39c63c9384b99784$var$noop() {}
function $39c63c9384b99784$var$deferToPhase(phase) {
    switch(phase){
        case (0, $9Fc44.PHASE).PAINT:
            return (0, $56LFI.postTask)($39c63c9384b99784$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $9Fc44.PHASE).AFTER_PAINT:
            return (0, $56LFI.postTask)($39c63c9384b99784$var$noop, {
                priority: 'user-visible'
            });
        case (0, $9Fc44.PHASE).LAZY:
            return (0, $56LFI.postTask)($39c63c9384b99784$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $39c63c9384b99784$var$lazyProxy(loader, { defer: defer = (0, $9Fc44.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $f8v34.isNodeEnvironment)();
    const dataLazyId = (0, $ewDOk.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/ban-types
    const LazyInternal = isServer ? (0, $dXi4e.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $4yMFN.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $1yW1K.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $kLgjN.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$39c63c9384b99784$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $j4Chq.retry)(deferredLoader, {
                    delay: (0, $1QGnA.RETRY_DELAY),
                    factor: (0, $1QGnA.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $f8v34.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $kLgjN.getConfig)();
        return (0, $apCPx.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $9Fc44.PHASE).PAINT ? (0, $1QGnA.PRIORITY).HIGH : (0, $1QGnA.PRIORITY).LOW);
        return (0, $lx2SU.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        moduleId: moduleId,
        preload: preload
    });
}
const $39c63c9384b99784$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $9Fc44.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $9Fc44.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $9Fc44.PHASE).LAZY
    }
};
function $39c63c9384b99784$export$c952e5f94576010e(loader, opts) {
    return $39c63c9384b99784$var$lazyProxy(loader, {
        ...$39c63c9384b99784$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $39c63c9384b99784$export$291dd592399bdafa(loader, opts) {
    return $39c63c9384b99784$var$lazyProxy(loader, {
        ...$39c63c9384b99784$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $39c63c9384b99784$export$488013bae63b21da(loader, opts) {
    return $39c63c9384b99784$var$lazyProxy(loader, {
        ...$39c63c9384b99784$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}
module.exports["lazyForPaint"] = $39c63c9384b99784$export$c952e5f94576010e;
module.exports["lazy"] = $39c63c9384b99784$export$488013bae63b21da;

});

parcelRegister("apCPx", function(module, exports) {
const $1276710975238522$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $1276710975238522$export$303f43e55cf1ef2f;

});

parcelRegister("kLgjN", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("7okWR")).MODE);

var $7okWR = parcelRequire("7okWR");

const $e504f67654901183$var$DEFAULT_CROSS_ORIGIN = undefined;
const $e504f67654901183$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $e504f67654901183$var$DEFAULT_MODE = (0, $7okWR.MODE).HYDRATE;
const $e504f67654901183$var$DEFAULT_RETRY = 2;
const $e504f67654901183$var$nullFunction = ()=>{};
const $e504f67654901183$var$config = {
    crossOrigin: $e504f67654901183$var$DEFAULT_CROSS_ORIGIN,
    manifest: $e504f67654901183$var$DEFAULT_MANIFEST,
    mode: $e504f67654901183$var$DEFAULT_MODE,
    retry: $e504f67654901183$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $e504f67654901183$var$nullFunction,
    usePostTaskPhases: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $e504f67654901183$export$44487a86467333c3 = ()=>$e504f67654901183$var$config;
const $e504f67654901183$export$940a7873bb071df8 = (nextConfig)=>{
    $e504f67654901183$var$config.crossOrigin = nextConfig.crossOrigin ?? $e504f67654901183$var$DEFAULT_CROSS_ORIGIN;
    $e504f67654901183$var$config.manifest = nextConfig.manifest ?? $e504f67654901183$var$DEFAULT_MANIFEST;
    $e504f67654901183$var$config.mode = nextConfig.mode ?? $e504f67654901183$var$DEFAULT_MODE;
    $e504f67654901183$var$config.retry = nextConfig.retry ?? $e504f67654901183$var$DEFAULT_RETRY;
    $e504f67654901183$var$config.react18 = nextConfig.react18 ?? false;
    $e504f67654901183$var$config.onChunkRender = nextConfig.onChunkRender ?? $e504f67654901183$var$nullFunction;
    $e504f67654901183$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $e504f67654901183$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $e504f67654901183$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $e504f67654901183$var$config.environment = nextConfig.environment ?? undefined;
};
module.exports["getConfig"] = $e504f67654901183$export$44487a86467333c3;

});

parcelRegister("7okWR", function(module, exports) {
const $601581d32aa16723$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $601581d32aa16723$export$e48589d9e4824227;

});

parcelRegister("9Fc44", function(module, exports) {
const $b48507ce9ad5736e$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $b48507ce9ad5736e$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $b48507ce9ad5736e$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $b48507ce9ad5736e$export$4831ef3968ea94ef;

});

parcelRegister("f8v34", function(module, exports) {

var $ewDOk = parcelRequire("ewDOk");

const $a30db2f3536f8178$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $a30db2f3536f8178$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $a30db2f3536f8178$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $a30db2f3536f8178$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $a30db2f3536f8178$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $a30db2f3536f8178$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $a30db2f3536f8178$export$283635c04a02cc36;
module.exports["attrToProp"] = $a30db2f3536f8178$export$62bf630d0de3d781;

});

parcelRegister("ewDOk", function(module, exports) {
$parcel$export(module.exports, "default", () => $24a469602f8fbe4d$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $24a469602f8fbe4d$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("4yMFN", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kLgjN = parcelRequire("kLgjN");
var $7okWR = parcelRequire("7okWR");


var $9Fc44 = parcelRequire("9Fc44");


var $kzxKD = parcelRequire("kzxKD");


var $6BYq1 = parcelRequire("6BYq1");


var $5fcqR = parcelRequire("5fcqR");


var $7ox5o = parcelRequire("7ox5o");


var $g3XHT = parcelRequire("g3XHT");


var $3slJ6 = parcelRequire("3slJ6");


var $boGZ5 = parcelRequire("boGZ5");


var $fPAF0 = parcelRequire("fPAF0");

function $c4aea8fb5847920a$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $9Fc44.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $9Fc44.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases } = (0, $kLgjN.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $42omo.useContext)((0, $7ox5o.LazySuspenseContext));
        const profiler = (0, $42omo.useContext)((0, $5fcqR.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $g3XHT.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $42omo.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $fPAF0.useSubscription)({
                context: (0, $kzxKD.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $9Fc44.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $fPAF0.useSubscription)({
                context: (0, $6BYq1.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $42omo.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $9Fc44.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $kLgjN.getConfig)().mode === (0, $7okWR.MODE).RENDER ? /*#__PURE__*/ (0, $l998X.jsx)((0, $boGZ5.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3slJ6.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases
        ]);
        (0, $42omo.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $kLgjN.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $7okWR.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(ResolvedLazy, {
            ...props
        });
    };
}
module.exports["createComponentClient"] = $c4aea8fb5847920a$export$6898b5504b58699a;

});

parcelRegister("kzxKD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jCY1s = parcelRequire("jCY1s");

const $1dab1d0aa35931a7$export$9ba3fe09d15de47b = (0, $42omo.createContext)({
    subscribe: ()=>(0, $jCY1s.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $1dab1d0aa35931a7$export$9ba3fe09d15de47b;

});

parcelRegister("jCY1s", function(module, exports) {
const $9ee2b70a231b494b$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $9ee2b70a231b494b$export$276c7dbda7675aec;

});

parcelRegister("6BYq1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9Fc44 = parcelRequire("9Fc44");


var $fIaok = parcelRequire("fIaok");


var $9gNpe = parcelRequire("9gNpe");

let $744298217eb4d9b7$var$CURRENT_PHASE = (0, $9Fc44.PHASE).PAINT;
const $744298217eb4d9b7$export$5f80f094fd31fffd = (phase)=>{
    $744298217eb4d9b7$var$CURRENT_PHASE = phase;
    (0, $fIaok.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $744298217eb4d9b7$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $9gNpe.createSubscribe)((0, $fIaok.LISTENERS)),
    currentValue: ()=>$744298217eb4d9b7$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $744298217eb4d9b7$export$5f80f094fd31fffd((0, $9Fc44.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$744298217eb4d9b7$export$5f80f094fd31fffd((0, $9Fc44.PHASE).PAINT)
    }
});
const $744298217eb4d9b7$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($744298217eb4d9b7$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["LazyPhaseContext"] = $744298217eb4d9b7$export$5a25eca35e5debcb;

});

parcelRegister("fIaok", function(module, exports) {
const $260cf0c0288f2472$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $260cf0c0288f2472$export$81b9c458a026d68f;

});

parcelRegister("9gNpe", function(module, exports) {
const $4519a9c2356c8a18$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $4519a9c2356c8a18$export$364097d812234b3f;

});

parcelRegister("5fcqR", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $01af053d839cf5fd$export$e2d53c0cbedd2710 = {
    current: null
};
const $01af053d839cf5fd$export$8146ab57a3f7a7cb = (0, $42omo.createContext)($01af053d839cf5fd$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $01af053d839cf5fd$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $01af053d839cf5fd$export$8146ab57a3f7a7cb;

});

parcelRegister("7ox5o", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kLgjN = parcelRequire("kLgjN");
var $7okWR = parcelRequire("7okWR");

const $cff3811e03675442$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
    setFallback: ()=>{
        if ((0, $kLgjN.getConfig)().mode === (0, $7okWR.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $cff3811e03675442$export$c33990e84065970c;

});

parcelRegister("g3XHT", function(module, exports) {
const $f0b861be6fd383a5$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $f0b861be6fd383a5$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$f0b861be6fd383a5$export$6aa69c1258005366]: true
    });
    return error;
};
const $f0b861be6fd383a5$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($f0b861be6fd383a5$export$6aa69c1258005366);
module.exports["createLoaderError"] = $f0b861be6fd383a5$export$c73a6a6f0bf7d425;

});

parcelRegister("3slJ6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $f8v34 = parcelRequire("f8v34");

const $d4d1572dc5458d03$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                type: "hidden",
                "data-lazy-begin": id
            }),
            content.map((el, i)=>{
                const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
                const props = Array.from(attributes).reduce((0, $f8v34.attrToProp), {
                    key: String(i)
                });
                // text node
                if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
                // childless tag
                if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
                // tag with content
                return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), {
                    ...props,
                    dangerouslySetInnerHTML: {
                        __html: ''
                    },
                    suppressHydrationWarning: true
                });
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                type: "hidden",
                "data-lazy-end": id
            })
        ]
    });
};
module.exports["PlaceholderFallbackHydrate"] = $d4d1572dc5458d03$export$ca5b8fbc835d95e4;

});

parcelRegister("boGZ5", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5fcqR = parcelRequire("5fcqR");


var $kzxKD = parcelRequire("kzxKD");


var $7ox5o = parcelRequire("7ox5o");

function $78967379450566ff$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $78967379450566ff$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    const profilerContext = (0, $42omo.useContext)((0, $5fcqR.ProfilerContext)).current;
    const waitContext = (0, $42omo.useContext)((0, $kzxKD.WaitContext));
    const suspenseContext = (0, $42omo.useContext)((0, $7ox5o.LazySuspenseContext));
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($78967379450566ff$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $78967379450566ff$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $78967379450566ff$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, $l998X.jsx)("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $78967379450566ff$export$d55db778a3e1446b;

});

parcelRegister("fPAF0", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $10addd599c71709d$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $10addd599c71709d$export$368b4214baeb914c;

});

parcelRegister("dXi4e", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $apCPx = parcelRequire("apCPx");


var $kLgjN = parcelRequire("kLgjN");
var $7okWR = parcelRequire("7okWR");


var $9Fc44 = parcelRequire("9Fc44");


var $7ox5o = parcelRequire("7ox5o");


var $f8v34 = parcelRequire("f8v34");


var $g3XHT = parcelRequire("g3XHT");

function $62b3c49a05e9a21d$var$load(moduleId, loader) {
    try {
        return (0, $f8v34.getExport)(loader());
    } catch (err) {
        throw (0, $g3XHT.createLoaderError)(err);
    }
}
function $62b3c49a05e9a21d$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $42omo.useContext)((0, $7ox5o.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $kLgjN.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $62b3c49a05e9a21d$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $7okWR.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $62b3c49a05e9a21d$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, $l998X.jsx)(Resolved, {
                ...props
            });
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("input", {
                    type: "hidden",
                    "data-lazy-begin": dataLazyId
                }),
                defer !== (0, $9Fc44.PHASE).LAZY && (0, $apCPx.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, $l998X.jsx)("link", {
                        rel: defer === (0, $9Fc44.PHASE).PAINT ? 'preload' : 'prefetch',
                        href: url,
                        crossOrigin: crossOrigin,
                        as: "script"
                    }, url)),
                Resolved ? /*#__PURE__*/ (0, $l998X.jsx)(Resolved, {
                    ...props
                }) : fallback,
                /*#__PURE__*/ (0, $l998X.jsx)("input", {
                    type: "hidden",
                    "data-lazy-end": dataLazyId
                })
            ]
        });
    };
}
class $62b3c49a05e9a21d$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = void 0;
        this.skipSsr = true;
    }
}
module.exports["createComponentServer"] = $62b3c49a05e9a21d$export$eb2e4b04351cdd9e;

});

parcelRegister("1QGnA", function(module, exports) {
const $e0f51a4da9ffcfc3$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e0f51a4da9ffcfc3$export$a339266ad71b2447 = 300;
const $e0f51a4da9ffcfc3$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e0f51a4da9ffcfc3$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e0f51a4da9ffcfc3$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e0f51a4da9ffcfc3$export$ba64c908e55507fe;

});

parcelRegister("1yW1K", function(module, exports) {
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $ecfde71ac061a273$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $ecfde71ac061a273$var$preloadIds;
const $ecfde71ac061a273$export$ac21d099cbc8d569 = (preload)=>{
    $ecfde71ac061a273$var$preloadIds = preload;
    try {
        $ecfde71ac061a273$var$preloadIds.forEach((lazyId)=>{
            const deffered = $ecfde71ac061a273$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $ecfde71ac061a273$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $ecfde71ac061a273$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($ecfde71ac061a273$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};
module.exports["createDeferred"] = $ecfde71ac061a273$export$e673efccd97e4223;

});

parcelRegister("lx2SU", function(module, exports) {

var $apCPx = parcelRequire("apCPx");


var $jCY1s = parcelRequire("jCY1s");


var $kLgjN = parcelRequire("kLgjN");


var $5fcqR = parcelRequire("5fcqR");


var $f8v34 = parcelRequire("f8v34");


var $1QGnA = parcelRequire("1QGnA");


var $gmp1c = parcelRequire("gmp1c");

function $53aa0b2a46a7822d$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $kLgjN.getConfig)();
    const assets = (0, $apCPx.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $gmp1c.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $53aa0b2a46a7822d$var$fakePromise = {
    then: ()=>$53aa0b2a46a7822d$var$fakePromise,
    catch: ()=>$53aa0b2a46a7822d$var$fakePromise,
    finally: ()=>$53aa0b2a46a7822d$var$fakePromise
};
function $53aa0b2a46a7822d$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $gmp1c.insertLinkTag)(href, rel));
        return $53aa0b2a46a7822d$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $53aa0b2a46a7822d$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jCY1s.noopCleanup;
}
function $53aa0b2a46a7822d$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $f8v34.isNodeEnvironment)()) return 0, $jCY1s.noopCleanup;
    (0, $5fcqR.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $1QGnA.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $53aa0b2a46a7822d$export$3af04dbcb01bad4d,
        $53aa0b2a46a7822d$export$1046fd6a49d5e7a,
        $53aa0b2a46a7822d$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jCY1s.noopCleanup;
}
module.exports["preloadAsset"] = $53aa0b2a46a7822d$export$25bad4aa00c45355;

});

parcelRegister("gmp1c", function(module, exports) {

var $jCY1s = parcelRequire("jCY1s");


var $kLgjN = parcelRequire("kLgjN");


var $5fcqR = parcelRequire("5fcqR");

function $7ac07eba9f17ef9a$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jCY1s.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $kLgjN.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $5fcqR.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $7ac07eba9f17ef9a$export$6610512821c8a4ce;

});

parcelRegister("j4Chq", function(module, exports) {
const $6152f1a19d36d750$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $6152f1a19d36d750$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $6152f1a19d36d750$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $6152f1a19d36d750$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $6152f1a19d36d750$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $6152f1a19d36d750$var$calculateDelay(context, policy);
        if (delay) await $6152f1a19d36d750$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $6152f1a19d36d750$export$9369b12211e1fce4;

});

parcelRegister("13zfh", function(module, exports) {

let $0c51694b0b5281d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c51694b0b5281d9$var$load("6WeF1").then(()=>parcelRequire('71Heu'));

});

parcelRegister("9AqRO", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $5c6b2d76155e66d2$var$LazyGitlabIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("iQ8bB")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon'
});

const $5c6b2d76155e66d2$var$LazyGitlabSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("iQ8bB")).then((m)=>m.GitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon'
});

const $5c6b2d76155e66d2$var$LazyGitlabIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("iQ8bB")).then((m)=>m.GitlabIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless'
});
const $5c6b2d76155e66d2$export$8b4e5326778cce0f = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabIconComponent, null));
const $5c6b2d76155e66d2$export$b828123bc19648f9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabSearchResultIconComponent, null));
const $5c6b2d76155e66d2$export$7e0d364467f49036 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabIconBorderlessComponent, null));
module.exports["GitlabIcon"] = $5c6b2d76155e66d2$export$8b4e5326778cce0f;
module.exports["GitlabSearchResultIcon"] = $5c6b2d76155e66d2$export$b828123bc19648f9;
module.exports["GitlabIconBorderless"] = $5c6b2d76155e66d2$export$7e0d364467f49036;

});

parcelRegister("iQ8bB", function(module, exports) {

let $db736ee8c78cb798$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db736ee8c78cb798$var$load("aqb5p").then(()=>parcelRequire('bEriH'));

});

parcelRegister("6Fa33", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $d90aa918544bbcee$var$LazyGitbookIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("cwkq9")).then((m)=>m.GitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/icon'
});

const $d90aa918544bbcee$var$LazyGitbookSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("cwkq9")).then((m)=>m.GitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon'
});
const $d90aa918544bbcee$export$6da1c7984975c183 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d90aa918544bbcee$var$LazyGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d90aa918544bbcee$var$LazyGitbookIconComponent, null));
const $d90aa918544bbcee$export$65b356f251826206 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d90aa918544bbcee$var$LazyGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d90aa918544bbcee$var$LazyGitbookSearchResultIconComponent, null));
module.exports["GitbookIcon"] = $d90aa918544bbcee$export$6da1c7984975c183;
module.exports["GitbookSearchResultIcon"] = $d90aa918544bbcee$export$65b356f251826206;

});

parcelRegister("cwkq9", function(module, exports) {

let $91d850555776a6c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91d850555776a6c8$var$load("5ko8Y").then(()=>parcelRequire('jXQsu'));

});

parcelRegister("6RZzG", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $a6322d6d29949407$var$LazyAzureDevopsIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9iyYo")).then((m)=>m.AzureDevopsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon'
});

const $a6322d6d29949407$var$LazyAzureDevopsSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9iyYo")).then((m)=>m.AzureDevopsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon'
});
const $a6322d6d29949407$export$2dcf704e717ca168 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6322d6d29949407$var$LazyAzureDevopsIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6322d6d29949407$var$LazyAzureDevopsIconComponent, null));
const $a6322d6d29949407$export$a64bb17da4dc2efb = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6322d6d29949407$var$LazyAzureDevopsSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6322d6d29949407$var$LazyAzureDevopsSearchResultIconComponent, null));
module.exports["AzureDevopsIcon"] = $a6322d6d29949407$export$2dcf704e717ca168;
module.exports["AzureDevopsSearchResultIcon"] = $a6322d6d29949407$export$a64bb17da4dc2efb;

});

parcelRegister("9iyYo", function(module, exports) {

let $6c50ec68f9a1653b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c50ec68f9a1653b$var$load("i0Kds").then(()=>parcelRequire('9bvJE'));

});

parcelRegister("ce4Ui", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $6e6a1954aec811f9$var$LazyGoogleDriveIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l71ry")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon'
});

const $6e6a1954aec811f9$var$LazyGoogleDriveSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l71ry")).then((m)=>m.GoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/search-result-icon'
});

const $6e6a1954aec811f9$var$LazyGoogleDriveIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l71ry")).then((m)=>m.GoogleDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon-borderless'
});

const $6e6a1954aec811f9$var$LazyGoogleDriveAppSelectorIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l71ry")).then((m)=>m.GoogleDriveAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/app-selector-icon'
});
const $6e6a1954aec811f9$export$e16bd899bb4eebf9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveIconComponent, null));
const $6e6a1954aec811f9$export$99050685a064f8e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveSearchResultIconComponent, null));
const $6e6a1954aec811f9$export$1f3b452b60b13122 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveIconBorderlessComponent, null));
const $6e6a1954aec811f9$export$e087ba40596ff085 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveAppSelectorIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveAppSelectorIconComponent, null));
module.exports["GoogleDriveIcon"] = $6e6a1954aec811f9$export$e16bd899bb4eebf9;
module.exports["GoogleDriveSearchResultIcon"] = $6e6a1954aec811f9$export$99050685a064f8e;
module.exports["GoogleDriveIconBorderless"] = $6e6a1954aec811f9$export$1f3b452b60b13122;
module.exports["GoogleDriveAppSelectorIcon"] = $6e6a1954aec811f9$export$e087ba40596ff085;

});

parcelRegister("l71ry", function(module, exports) {

let $f5eb5f0bb6b715c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5eb5f0bb6b715c3$var$load("ar6O2").then(()=>parcelRequire('dZv90'));

});


//# sourceMappingURL=google.35c64099.js.map
